import React, { useEffect, useState } from "react";
import { InternalBackButton } from "../../../../../components";
import { useSettings } from "../../../../../context";
import {
  getSeminarData,
  Language,
  SeminarArticle,
  seminarLanguageMap,
} from "../../../../../utils";

export const SeminarArticlePage: React.FC = () => {
  const pageIndex = Number(window.location.hash.replace("#", ""));
  const { language, processText, convertReactNode } = useSettings();
  const [seminarsData, setSeminarsData] = useState<SeminarArticle[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const response_en = await fetch(seminarLanguageMap[Language.EN]);
      const response = await fetch(seminarLanguageMap[language]);
      const data_en = await response_en.json();
      const data = await response.json();

      setSeminarsData(getSeminarData(data, data_en));
    };
    fetchData();
  }, [language]);

  const pageContent = seminarsData[pageIndex];
  const { img, title, date, content } = pageContent ?? {};
  return (
    <div className="flex flex-col gap-[24px]">
      {img && (
        <img src={process.env.PUBLIC_URL + img} alt={processText(title)} />
      )}

      <div className="text-heading-l">{processText(title)}</div>
      <div className="flex flex-row gap-[8px] items-center">
        <img
          className="w-[16px] h-[16px]"
          src={`${process.env.PUBLIC_URL}/assets/icons/calendar.svg`}
          alt={processText(title)}
        />
        <p className="text-body-s text-grey">{processText(date)}</p>
      </div>
      <div
        className="[&_a]:underline [&_ul]:space-y-6 [&_ul]:mt-6 [&_li]:text-medium" // 同时设置 space-y-6 和 mt-6
        dangerouslySetInnerHTML={{
          __html: convertReactNode(content) as string,
        }}
      />
      <hr />
      <InternalBackButton targetUrl="/events-promotion?section=seminar_workshop" />
    </div>
  );
};
